import { number, object, string } from "yup"
import { buildSchema } from "./util/build-schema"
import { isValidWallet } from "./util/cryptocurrency-wallet-address"

const MAX_NICKNAME_LEN = 20

const schema = object({
  asset: string().required(),
  address: string()
    .test(
      "address",
      "yup.digitalAssetCustomerAddress.address.invalid",
      function (value, context) {
        const { valid, message } = isValidWallet(
          this.parent.asset as string,
          value ?? ""
        )
        if (message) {
          return context.createError({ message })
        }

        return valid
      }
    )
    .required(),
  memo: string(),
  name: string().max(MAX_NICKNAME_LEN).required(),
  id: number().required(),
})

export const digitalAssetCustomerAddressSchema = buildSchema(
  "DigitalAssetCustomerAddress",
  schema
)
